// extracted by mini-css-extract-plugin
module.exports = {"settingsContainer":"settings_settingsContainer__1BhxV","settingSection":"settings_settingSection__YRVT5"};